/**
 * Returns a list with stopwords for the Spanish passive voice assessment.
 * @returns {Array} The list with stopwords.
 */
export default function() {
	return [
		"pero",
		"ora",
		"aunque",
		"aun",
		"mientras",
		"porque",
		"apenas",
		"si",
		"antes",
		"después",
		"cómo",
		"como",
		"empero",
		"que",
		"cuanto",
		"cuando",
		"cual",
		"cuales",
		"quién",
		"quien",
		"quienes",
		"dónde",
		"adónde",
		"cuyo",
		"cuyos",
		"cuya",
		"cuyas",
	];
}
